// extracted by mini-css-extract-plugin
module.exports = {"rateCardList":"RateCardList_rateCardList__1egQb","rateCard":"RateCardList_rateCard__2xhGC"};